import { useCallback, useContext } from "react";
import { useHistory } from "react-router";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { indexTypeContractByCompany } from "../../../../repositories/qerpapi/erp/faturamento/TipoContratosRepository";
import { findIndexes } from "../../../../repositories/qerpapi/erp/financeiro/IndicesRepository";
import { indexTypeAproval } from "../../../../repositories/qerpapi/erp/pub/TipoAprovacaoRepository";
import { notify } from "../../../../utils/notify";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";
import { GerenciamentoContratoFilterContext } from "../contexts/GerenciamentoContratoFilterContext";
import { ConfigurationContext } from "../contexts/ConfigurationContext";
import MaskService from "../../../../utils/mask/maskService";
import { validNotNull } from "../../../../utils/validations";
import {
  findTipoPagamento,
  findTypePaymentByFormOfPayment,
} from "../../../../repositories/qerpapi/erp/prouser/v1/TipoPagamento";
import {
  attachmentsContract,
  sendCancelContract,
  suspensionContract,
  activeContract,
  createContrato,
  editContract,
  includeAttachments,
  removeAttachments,
  getCancelLists,
  customShowContract,
} from "../../../../repositories/qerpapi/erp/faturamento/ContratoRepository";
import { updateContratoServico } from "../../../../repositories/qerpapi/erp/faturamento/ClassificacaoServicoRepository";
import getBase64 from "../../../../utils/getBase64";
import { findAgencia } from "../../../../repositories/qerpapi/erp/financeiro/AgenciasRepository";
import Swal from "sweetalert2";
import { GlobalVariables } from "../../../../GlobalVariables";
import {
  searchByCompany,
  downloadPdf,
  sendEmail,
} from "../../../../repositories/qerpapi/erp/faturamento/ContratoModeloRepository";
import { b64toBlob } from "../../../../utils/file64toBlob";
import { findTag } from "../../../../repositories/qerpapi/erp/faturamento/TagRepository";

import moment from "moment";
import "moment/locale/pt-br";
import {
  getContractCancelledInstallments,
  reactivateContract,
} from "../../../../repositories/qerpapi/v3/contrato";
import { findProgressoConfiguracoes } from "../../../../repositories/qerpapi/erp/prouser/v2/EmpresasRepository";
import {
  fetchAllOptions as fetchLeadOriginOptions,
  store as storeLeadOrigin,
  update as updateLeadOrigin,
} from "../../../../repositories/qerpapi/v3/faturamento/OrigemLeadRepository";
import {
  fetchAllOptions as fetchSaleTypeOptions,
  store as storeSaleType,
  update as updateSaleType,
} from "../../../../repositories/qerpapi/v3/faturamento/TipoVendaRepository";

export default function useGerenciamentoContratoController() {
  const {
    setLoading,
    setErrorsSubmit,
    clientInfos,
    setClientInfos,
    commercialPartnerInfos,
    setCommercialPartnerInfos,
    setIdContract,
    proposedNumber,
    setProposedNumber,
    setCpfCnpj,
    modality,
    setModality,
    typeService,
    setTypeService,
    setListTypeService,
    modelContract,
    setModelContract,
    setListModelContract,
    approvalType,
    setApprovalType,
    typeReadjustment,
    setTypeReadjustment,
    setListTypeReadjustment,
    dateEmission,
    setDateEmission,
    firstDueDate,
    setFirstDueDate,
    setDayDueDate,
    setPeriodicity,
    listPeriodicity,
    validity,
    setValidity,
    salesmanInfos,
    setSalesmanInfos,
    financialResponsibleEnabled,
    setFinancialResponsibleEnabled,
    financialResponsibleInfos,
    setFinancialResponsibleInfos,
    originalFinancialResponsibleId,
    setOriginalFinancialResponsibleId,
    setTotalService,
    itemsTable,
    setItemsTable,
    typePayment,
    setListTypePayment,
    setListBank,
    regimeCompetency,
    setRegimeCompetency,
    regimeCompetencyList,
    selectService,
    setSelectService,
    valueService,
    setValueService,
    amountService,
    setAmountService,
    perfilTributarioLinhaModal,
    setPerfilTributarioLinhaModal,
    setErrorsSubmitTypeService,
    reasonForCancellation,
    setReasonForCancellation,
    cancelFrom,
    listModality,
    setTypePayment,
    setGenerateBillet,
    setIssueNfse,
    setGenerateFinancialStatement,
    setSendByEmail,
    setAttachNfse,
    setAttachFinancialStatement,
    setAttachBillet,
    setArrachExpense,
    listBillet,
    setBank,
    setTypeBillet,
    setListFormOfPayment,
    setObservation,
    setUploadFilesAttachment,
    formOfPayment,
    totalService,
    setItensInstallments,
    itensInstallments,
    dayDueDate,
    typeBillet,
    bank,
    generateBillet,
    generateFinancialStatement,
    sendByEmail,
    attachNfse,
    attachBillet,
    attachFinancialStatement,
    arrachExpense,
    periodicity,
    setListApprovalType,
    setFormOfPayment,
    observation,
    issueNfse,
    uploadFilesAttachment,
    savedAttachments,
    setSavedAttachments,
    setMainLoading,
    setContractCanceled,
    setContractStatus,
    setDisabledPaymentOptions,
    disabledPaymentOptions,
    setItensTable,
    valueInNote,
    setValueInNote,
    issueType,
    setIssueType,
    setModalCancelamentoContratoOpen,
    initialBillingInformation,
    setInitialBillingInformation,
    applyBillingRule,
    setApplyBillingRule,
    billingRule,
    setBillingRule,
    setProgressoConfiguracoesNfse,
    leadOrigin,
    setLeadOrigin,
    setListLeadOrigin,
    saleType,
    setSaleType,
    setListSaleType,
  } = useContext(GerenciamentoContratoContext);

  const { configuration } = useContext(ConfigurationContext);

  const { listBillingRules } = useContext(GerenciamentoContratoFilterContext);

  const { queryParams } = useContext(QueryParamsContext);

  const { push } = useHistory();

  const handleSelectClient = (setModalClient, selectedClient) => {
    setClientInfos(selectedClient[0]);
    setCpfCnpj(selectedClient[0]?.cpfcnpj);
    setModalClient(false);
  };

  const handleSelectFinancialResponsible = (setModal, selected) => {
    setFinancialResponsibleInfos(selected[0] ?? null);
    setModal(false);
  };

  const handleSelectSalesman = (setModalSalesman, selectedSalesman) => {
    setSalesmanInfos(selectedSalesman[0]);
    setModalSalesman(false);
  };

  const handleSelectCommercialPartner = (setModal, selected) => {
    setCommercialPartnerInfos(selected[0]);
    setModal(false);
  };

  const getBankList = useCallback(
    (requestResult = [], onlyView = false, userId = null, companyId = null) => {
      return requestResult
        .filter((agency) =>
          onlyView
            ? agency.idempresa === companyId
            : agency.usuarios?.some((user) => user.id === Number(userId)) &&
              agency.idempresa === companyId
        )
        .map((agency) => ({
          value: agency.id,
          label: `${agency?.apelido} (${agency?.contacorrente})`,
          codBank: agency.banco?.codigo,
        }));
    },
    []
  );

  const handleData = useCallback(
    async (id) => {
      if (
        !queryParams?.empresa_cnpj ||
        !queryParams?.empresa_id ||
        !queryParams?.usuario_id
      )
        return;

      try {
        setLoading(true);

        const dataListReadjustments = [];
        const dataListTypeContract = [];
        const dataListTypeAproval = [];
        const dataListTypePayment = [];
        const dataListContracts = [];

        const [
          callbackIndexes,
          callbackTypeContract,
          callbackTypeAproval,
          callbackTypePayment,
          callbackBank,
          callbackContracts,
          callbackProgressoConfiguracoesNfse,
          leadOriginOptions,
          saleTypeOptions,
        ] = await Promise.all([
          findIndexes(queryParams?.empresa_cnpj),
          indexTypeContractByCompany({
            empresa_cnpj: queryParams?.empresa_cnpj,
            empresa_id: queryParams?.empresa_id,
            where: { ativo: "S" },
          }),
          indexTypeAproval({
            empresa_cnpj: queryParams?.empresa_cnpj,
          }),
          findTipoPagamento(
            queryParams?.empresa_cnpj,
            {},
            "empresasformaspgto,empresasformaspgto.parcelasCondicaoPgto"
          ),
          findAgencia(
            queryParams?.empresa_cnpj,
            queryParams?.usuario_id,
            "banco,usuarios"
          ),
          searchByCompany({
            empresa_cnpj: queryParams.empresa_cnpj,
            companyId: parseInt(queryParams.empresa_id),
            orderByColumn: "id",
          }),
          findProgressoConfiguracoes(
            queryParams.empresa_cnpj,
            queryParams.empresa_id
          ),
          fetchLeadOriginOptions(),
          fetchSaleTypeOptions(),
        ]);

        setProgressoConfiguracoesNfse(
          callbackProgressoConfiguracoesNfse?.success
            ? callbackProgressoConfiguracoesNfse?.data ?? null
            : null
        );

        if (
          !callbackIndexes?.success ||
          !callbackTypeContract?.success ||
          !callbackTypeAproval?.success ||
          !callbackTypePayment?.success ||
          !callbackBank?.success
        ) {
          setListLeadOrigin(leadOriginOptions || []);
          setListSaleType(saleTypeOptions || []);
          return notify("Erro ao buscar listas.");
        }

        callbackIndexes?.data.forEach((readjustments) => {
          dataListReadjustments.push({
            value: readjustments?.id,
            label: readjustments?.descricao,
          });
        });

        callbackTypeContract?.data.forEach((service) => {
          dataListTypeContract.push({
            value: service?.id,
            label: service?.descricao,
            contrato_modelo_id: service?.contrato_modelo_id,
          });
        });

        callbackTypeAproval?.data.forEach((typeAproval) => {
          dataListTypeAproval.push({
            value: typeAproval?.id,
            label: typeAproval?.descricao,
          });
        });

        callbackTypePayment?.data.forEach((typePayment) => {
          dataListTypePayment.push({
            value: typePayment?.id,
            label: typePayment?.descricao,
            formaspgto: typePayment.empresasformaspgto
              .filter((e) => e.st_ativo !== "N")
              .map((formapagto) => ({
                value: formapagto.id,
                amount: formapagto.qtdepagtos,
                label: formapagto.descricao,
                parcelas_condicao_pgto:
                  formapagto?.parcelas_condicao_pgto || [],
              })),
          });
        });

        callbackContracts?.data.forEach((contracts) => {
          dataListContracts.push({
            value: contracts?.id,
            label: contracts?.descricao,
          });
        });

        setListTypeService(dataListTypeContract);
        setListTypeReadjustment(dataListReadjustments);
        setListApprovalType(dataListTypeAproval);
        setListTypePayment(dataListTypePayment);
        setListModelContract(dataListContracts);
        setListLeadOrigin(leadOriginOptions || []);
        setListSaleType(saleTypeOptions || []);

        if (id) {
          const dataItemsContract = [];
          const dataAttachments = [];

          const callbackContract = await customShowContract({
            empresa_cnpj: queryParams.empresa_cnpj,
            idContract: id,
            gfToken: queryParams.gfAccessToken,
          });

          const callbackAttachments = await attachmentsContract({
            empresa_cnpj: queryParams.empresa_cnpj,
            idContract: id,
          });

          if (!callbackContract?.success || !callbackAttachments?.success)
            return notify("Erro ao buscar dados do contrato.");

          const { data } = callbackContract;

          data.contratoitens.forEach((item) => {
            dataItemsContract.push({
              id: dataItemsContract.length,
              keyService: item?.id,
              service: item?.contratoservicos,
              valueItem: MaskService.toMask(
                "decimal",
                parseFloat(item?.valorunitario).toFixed(
                  configuration?.contract_decimal_size || 2
                ),
                configuration?.contract_decimal_size || 2
              ),
              amountItem: item?.quantidade,
              valueTotal: MaskService.toMask(
                "decimal",
                parseFloat(item?.valortotal).toFixed(
                  configuration?.contract_decimal_size || 2
                ),
                configuration?.contract_decimal_size || 2
              ),
              cancelDate: !!item.motivocancelamento_id
                ? item?.data_cancelamento || ""
                : "",
              rowError: !!item.motivocancelamento_id,
            });
          });

          const dataBillet = listBillet.find(
            (comp) =>
              comp?.value ===
              data.contasreceber?.find((e) => e.idagencia)?.tipo_boleto
          );

          callbackAttachments?.data?.forEach((attachments) => {
            dataAttachments.push({
              id: attachments?.id,
              error: false,
              name: attachments?.anexo_nome,
              file: attachments?.base64,
              uploaded: false,
              lastModifiedDate: attachments?.update_at,
              s3_key: attachments?.s3_key,
              preview: `data:image/png;base64,${attachments.base64}`,
            });
          });

          const dataTypeService = dataListTypeContract.find(
            (comp) => comp?.value === data.idtipocontrato
          );

          const dataApprovalType = dataListTypeAproval.find(
            (comp) => comp?.value === data.tipo_aprovacao_id
          );

          const dataLeadOrigin = (leadOriginOptions || []).find(
            (comp) => comp?.value === data.origem_lead_id
          );

          const dataSaleType = (saleTypeOptions || []).find(
            (comp) => comp?.value === data.tipo_venda_id
          );

          const dataTypeReadjustment = dataListReadjustments.find(
            (comp) => comp?.value === data.idtiporeajuste
          );

          const dataTypePayment = dataListTypePayment.find(
            (comp) => comp?.value === data.idtipopagamento
          );

          const dataModality = listModality.find(
            (comp) => comp?.value === data.modalidade
          );

          const dataModelContract = dataListContracts.find(
            (comp) => comp?.value === data?.id_modelo_contrato
          );

          const dataPeriodicity = listPeriodicity.find(
            (comp) => comp.value === (data.reajusteperiod || "1").toString()
          );

          const dataRegimeCompetency = regimeCompetencyList.find(
            (comp) => comp?.value === data.regime_competencia
          );

          setClientInfos(data.cliente ?? null);
          setCpfCnpj(data.cliente?.cpfcnpj ?? null);
          setProposedNumber(data.proposta ?? null);
          setIdContract(data.id ?? null);
          setModality(dataModality ?? null);
          setTypeService(dataTypeService ?? null);
          setModelContract(dataModelContract ?? null);
          setApprovalType(dataApprovalType ?? null);
          setTypeReadjustment(dataTypeReadjustment ?? null);
          setDateEmission(data.dataemissao ?? null);
          setFirstDueDate(data.datavencimento1 ?? null);
          setDayDueDate(data.dia_vencimento ?? null);
          setPeriodicity(dataPeriodicity || null);
          setValidity(data.vigencia_renovacao ?? null);
          setRegimeCompetency(dataRegimeCompetency ?? null);
          setSalesmanInfos(data.vendedor ?? null);
          setCommercialPartnerInfos(data.parceirocomercial ?? null);
          setOriginalFinancialResponsibleId(
            data.cliente_responsavel_financeiro_id ?? null
          );
          setFinancialResponsibleEnabled(
            !!data.cliente_responsavel_financeiro_id
          );
          setFinancialResponsibleInfos(
            data.cliente_responsavel_financeiro ?? null
          );
          setLeadOrigin(dataLeadOrigin ?? null);
          setSaleType(dataSaleType ?? null);
          setItemsTable(dataItemsContract ?? null);
          setTypePayment(dataTypePayment ?? null);
          setGenerateBillet(data.flag_gerar_boleto === 1);
          setTypeBillet(dataBillet ?? null);
          setIssueNfse(data.flag_emitir_nfse === 1);
          setIssueType(data.padrao_contrato_tipo_emissao_nfse === 0);
          setValueInNote(data.flag_valor_nota === 1);
          setGenerateFinancialStatement(
            data.flag_gerar_demonstrativo_financeiro === 1
          );
          setSendByEmail(data.flag_enviar_email === 1);
          setAttachNfse(data.flag_email_nfse === 1);
          setAttachFinancialStatement(
            data.flag_email_demonstrativo_financeiro === 1
          );
          setAttachBillet(data.flag_email_boleto === 1);
          setArrachExpense(data.flag_email_comp_desp === 1);
          setObservation(data.obs);
          setUploadFilesAttachment(dataAttachments);
          setSavedAttachments(dataAttachments);
          setContractCanceled(data.status === "C");
          setContractStatus(data.status);
          setProposedNumber(data.proposta || "");
          setApplyBillingRule(!!data?.regua_cobranca_id);
          setBillingRule({
            value: data?.regua_cobranca_id || null,
            label:
              listBillingRules.find(
                (rule) => rule.value === data?.regua_cobranca_id
              )?.label || "",
          });

          // Desabilita os campos de Tipo e Forma de pagamento
          // caso encontre alguma Conta a Receber que não esteja
          // em aberto ou seja um contrato Recorrente.
          setDisabledPaymentOptions(
            data.contasreceber.some((e) => e.situacaodocto !== "00")
          );

          let dataFormOfPayment = [];
          if (data.idformapagamento) {
            const callbackFormOfPayment = await findTypePaymentByFormOfPayment({
              empresa_cnpj: queryParams?.empresa_cnpj,
              idTypePayment: dataTypePayment?.value,
              include:
                "empresasformaspgto,empresasformaspgto.parcelasCondicaoPgto",
              where: { st_ativo: "S" },
            });

            if (!callbackFormOfPayment?.success)
              return notify("Erro ao buscar formas de pagamentos.");

            const listPayment = [];

            callbackFormOfPayment?.data?.empresasformaspgto.forEach((item) => {
              listPayment.push({
                value: item?.id,
                amount: item?.qtdepagtos,
                label: item?.descricao,
                parcelas_condicao_pgto: item?.parcelas_condicao_pgto || [],
              });
            });

            dataFormOfPayment = listPayment.find(
              (comp) => comp?.value === data.idformapagamento
            );

            setListFormOfPayment(listPayment);
            setFormOfPayment(dataFormOfPayment ?? null);
          }

          let tempItensInstallments = [];
          if (data.modalidade === GlobalVariables.contract.modality.separate) {
            data.contasreceber?.sort(function (a, b) {
              return a.numerodocto.localeCompare(b.numerodocto);
            });

            tempItensInstallments =
              data.contasreceber?.map((cr, i) => ({
                keyService: cr.id,
                documentNumber:
                  cr.numerodocto?.split("-")?.[1] ||
                  `${i + 1}/${data.contasreceber.length}`,
                value: parseFloat(cr.valordocto),
                dueDate: moment(cr.datavencto).format("YYYY-MM-DD"),
              })) || [];

            setItensInstallments(tempItensInstallments);
          }
          const bankList = getBankList(
            callbackBank.data,
            data.contasreceber.some((e) => e.situacaodocto !== "00"),
            queryParams.usuario_id,
            queryParams.empresa_id
          );
          setListBank(bankList);

          let dataBank = bankList.find(
            (comp) =>
              comp?.value ===
              data.contasreceber?.find(
                (e) => e.idagencia && ["00"].includes(e.situacaodocto)
              )?.idagencia
          );

          if (!dataBank && data.contasreceber?.length > 0) {
            dataBank = bankList.find(
              (comp) =>
                comp?.value ===
                data.contasreceber?.find((e) => e.idagencia)?.idagencia
            );
          }
          setBank(dataBank ?? null);

          setInitialBillingInformation({
            itensInstallments: tempItensInstallments,
            formOfPayment: dataFormOfPayment,
            typePayment: dataTypePayment,
          });
        } else {
          const defaultDataTypePayment = dataListTypePayment.find((comp) =>
            verifyIsBoletoOrTransferency(comp?.label, ["boleto"])
          );
          setTypePayment(defaultDataTypePayment ?? null);

          setListBank(
            getBankList(
              callbackBank.data,
              false,
              queryParams.usuario_id,
              queryParams.empresa_id
            )
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line
    [
      queryParams.usuario_id,
      queryParams.empresa_cnpj,
      queryParams.empresa_id,
      setLoading,
      setListApprovalType,
      setListTypeReadjustment,
      setListBank,
      setListTypePayment,
      setListTypeService,
      listModality,
      listPeriodicity,
      listBillet,
      regimeCompetencyList,
      setListFormOfPayment,
      setClientInfos,
      setCpfCnpj,
      setProposedNumber,
      setIdContract,
      setModality,
      setTypeService,
      setModelContract,
      setApprovalType,
      setTypeReadjustment,
      setDateEmission,
      setFirstDueDate,
      setDayDueDate,
      setPeriodicity,
      setValidity,
      setRegimeCompetency,
      setSalesmanInfos,
      setArrachExpense,
      setAttachBillet,
      setAttachFinancialStatement,
      setAttachNfse,
      setBank,
      setFormOfPayment,
      setGenerateBillet,
      setGenerateFinancialStatement,
      setIssueNfse,
      setItemsTable,
      setSendByEmail,
      setTypeBillet,
      setTypePayment,
      setObservation,
      setUploadFilesAttachment,
      setSavedAttachments,
      setContractCanceled,
      setContractStatus,
      setCommercialPartnerInfos,
      setDisabledPaymentOptions,
      setItensInstallments,
      setListModelContract,
      setValueInNote,
      getBankList,
      configuration,
      setProgressoConfiguracoesNfse,
    ]
  );

  const rulesToStore = (validate) => {
    if (validity && !MaskService.isValid("month-and-year", validity)) {
      validate.errorsValidation.validity = true;
      validate.error = true;
    }

    return validate;
  };

  const confirmEditContract = (id, newContract = false, edition = false) => {
    const jsonValidMain = [
      {
        key: "clientInfos",
        value: clientInfos,
      },
      {
        key: "modality",
        value: modality,
      },
      ...(configuration?.utiliza_nova_nfse === 0
        ? [
            {
              key: "typeService",
              value: typeService,
            },
          ]
        : []),
      {
        key: "modelContract",
        value: modelContract,
      },

      {
        key: "dateEmission",
        value: dateEmission,
      },
      {
        key: "regimeCompetency",
        value: regimeCompetency,
      },
    ];

    if (modality?.value === GlobalVariables.contract.modality.recurring) {
      jsonValidMain.push(
        ...[
          {
            key: "typeReadjustment",
            value: typeReadjustment,
          },
          {
            key: "validity",
            value: validity,
          },
          {
            key: "firstDueDate",
            value: firstDueDate,
          },
          {
            key: "dayDueDate",
            value: dayDueDate,
          },
        ]
      );
    }

    if (modality?.value === GlobalVariables.contract.modality.separate)
      jsonValidMain.push({
        key: "formOfPayment",
        value: formOfPayment,
      });

    if (bank?.codBank === "000")
      jsonValidMain.push({
        key: "typeBillet",
        value: typeBillet,
      });

    if (generateBillet) {
      jsonValidMain.push({
        key: "bank",
        value: bank,
      });
    }

    if (applyBillingRule) {
      jsonValidMain.push({
        key: "billingRule",
        value: billingRule,
      });
    }

    let validateSubmit = id
      ? validNotNull(jsonValidMain)
      : rulesToStore(validNotNull(jsonValidMain));

    setErrorsSubmit({
      ...validateSubmit?.errorsValidation,
    });

    if (validateSubmit?.error)
      return notify(
        "Verifique se os campos foram preenchidos corretamente.",
        true,
        "warning"
      );

    if (!edition && moment(firstDueDate).diff(moment(), "days") < 0) {
      return notify(
        "O campo 1º Vencimento do contrato não pode ser anterior à data atual.",
        true,
        "warning"
      );
    }

    if (!itemsTable.length)
      return notify("Insira um Item de Serviço no contrato.", true, "warning");

    if (configuration?.utiliza_nova_nfse === 1) {
      const linhaAtivaSemPerfilTributario = itemsTable.some(
        (item) =>
          !(item.reasonForCancellationId || item.cancelDate) &&
          !item?.service?.perfil_tributario_id
      );
      if (linhaAtivaSemPerfilTributario) {
        return notify(
          "Existem linhas de serviço ativas sem perfil tributário configurado. Edite cada item na grade e selecione o perfil antes de salvar.",
          true,
          "warning"
        );
      }
    }

    if (modality?.value === GlobalVariables.contract.modality.separate) {
      let installmentsValue = 0;
      for (let i = 0; i <= itensInstallments.length - 1; i++) {
        installmentsValue += itensInstallments[i].value;
      }

      if (
        parseFloat(
          installmentsValue.toFixed(configuration?.contract_decimal_size || 2)
        ) <
        MaskService.removeMaskDecimal(
          totalService,
          configuration?.contract_decimal_size || 2
        )
      ) {
        return notify("A soma das parcelas é menor que o valor do contrato."); //
      }
    }

    const hasActiveItems = itemsTable.find(
      (item) => !(item.reasonForCancellationId || item.cancelDate)
    );

    if (hasActiveItems) {
      return creatEditContract(id, newContract);
    } else {
      Swal.fire({
        title: "Atenção",
        icon: "warning",
        text: "Todos os itens do contrato foram cancelados, deseja realizar o cancelamento do contrato?",
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: "Voltar",
        confirmButtonText: "Confirmar",
        allowOutsideClick: false,
      }).then((res) => {
        if (res.isConfirmed) {
          setModalCancelamentoContratoOpen(true);
        }
      });
    }
  };

  const creatEditContract = async (id, newContract) => {
    try {
      let successMsg = "Contrato salvo com sucesso.";
      if (!id) {
        setLoading(true);
        const dataServices = [];
        const dataContractAttach = [];

        itemsTable.forEach((service) => {
          dataServices.push({
            idservico: service?.service?.id,
            quantidade: service?.amountItem,
            valorunitario: MaskService.removeMaskDecimal(
              service?.valueItem,
              configuration?.contract_decimal_size || 2
            ),
            valortotal: MaskService.removeMaskDecimal(
              service?.valueTotal,
              configuration?.contract_decimal_size || 2
            ),
            ...(configuration?.utiliza_nova_nfse === 1
              ? {
                  perfil_tributario_id:
                    service?.service?.perfil_tributario_id ?? null,
                }
              : {}),
          });
        });

        itensInstallments.forEach((attach) => {
          dataContractAttach.push({
            valor: attach?.value,
            vencimento: moment(attach?.dueDate).format("YYYY-MM-DD"),
          });
        });

        const body = [
          {
            ...(modality?.value === GlobalVariables.contract.modality.recurring
              ? {
                  dia_vencimento: dayDueDate,
                  datavencimento1: moment(firstDueDate).format("YYYY-MM-DD"),
                }
              : {}),
            idempresa: queryParams.empresa_id,
            idusuario: queryParams.usuario_id,
            idcliente: clientInfos?.id,
            id_parceirocomercial: commercialPartnerInfos?.id || null,
            modalidade: modality?.value,
            idtipocontrato: typeService?.value,
            reajusteperiod: periodicity?.value || null,
            total: MaskService.removeMaskDecimal(
              totalService,
              configuration?.contract_decimal_size || 2
            ),
            dataemissao: dateEmission,
            proposta: proposedNumber?.substring(0, 20) || "",
            idtipopagamento: typePayment?.value,
            formarecebimento: typePayment?.label,
            vigencia_renovacao: validity,
            idtiporeajuste: typeReadjustment?.value,
            tipoboleto: typeBillet?.value || null,
            status: "A",
            idformapagamento: formOfPayment?.value,
            regime_competencia: regimeCompetency?.value,
            idagencia: bank?.value || null,
            id_vendedor: salesmanInfos?.id || null,
            id_modelo_contrato: modelContract?.value,
            tipo_aprovacao_id: approvalType?.value,
            origem_lead_id: leadOrigin?.value || null,
            tipo_venda_id: saleType?.value || null,
            cliente_responsavel_financeiro_id: financialResponsibleEnabled
              ? financialResponsibleInfos?.id || null
              : null,
            flag_gerar_boleto:
              verifyIsBoletoOrTransferency(typePayment?.label || "") &&
              generateBillet
                ? 1
                : 0,
            flag_gerar_demonstrativo_financeiro: generateFinancialStatement
              ? 1
              : 0,
            flag_enviar_email: sendByEmail ? 1 : 0,
            flag_emitir_nfse: issueNfse ? 1 : 0,
            flag_valor_nota: valueInNote ? 1 : 0,
            padrao_contrato_tipo_emissao_nfse: issueNfse && !issueType ? 1 : 0,
            flag_email_nfse: attachNfse ? 1 : 0,
            flag_email_boleto:
              verifyIsBoletoOrTransferency(typePayment?.label || "") &&
              attachBillet
                ? 1
                : 0,
            flag_email_demonstrativo_financeiro: attachFinancialStatement
              ? 1
              : 0,
            flag_email_comp_desp: arrachExpense ? 1 : 0,
            applyBillingRule: applyBillingRule,
            origem: "ERP",
            contratoitens: dataServices,
            parcelas: dataContractAttach,
            obs: observation,
            regua_cobranca_id: billingRule?.value || null,
          },
        ];

        const callback = await createContrato({
          empresa_cnpj: queryParams.empresa_cnpj,
          body: {
            contratos: body,
          },
        });

        if (!callback?.success) return notify("Erro ao criar contrato.");

        successMsg = callback?.message || successMsg;

        id = callback?.data[0]?.id;
      } else {
        const acceptConditionEditContract = await Swal.fire({
          title: "Atenção",
          icon: "warning",
          text: "As alterações que impactam o contas a receber serão alterados somente nos títulos Em Carteira",
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonText: "Voltar",
          confirmButtonText: "Confirmar",
          allowOutsideClick: false,
        }).then((res) => {
          return res.isConfirmed;
        });

        if (!acceptConditionEditContract) {
          return;
        }

        const newFinancialResponsibleId = financialResponsibleEnabled
          ? financialResponsibleInfos?.id || null
          : null;

        if (
          (originalFinancialResponsibleId || null) !==
          (newFinancialResponsibleId || null)
        ) {
          const acceptFinancialResponsibleChange = await Swal.fire({
            title: "Atenção",
            icon: "warning",
            text:
              "Os contas a receber em carteira terão sua titularidade transferida para o novo responsável financeiro. Continuar?",
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: "Voltar",
            confirmButtonText: "Confirmar",
            allowOutsideClick: false,
          }).then((res) => res.isConfirmed);

          if (!acceptFinancialResponsibleChange) {
            return;
          }
        }

        setLoading(true);
        const dataService = [];

        itemsTable.forEach((item) => {
          dataService.push({
            id: item.keyService,
            servico_tipo: modality?.label.toLowerCase(),
            valor: MaskService.removeMaskDecimal(
              item?.valueItem,
              configuration?.contract_decimal_size || 2
            ),
            quantidade: parseInt(item?.amountItem),
            usuario_id: queryParams?.usuario_id,
            servico_id: item?.service?.id,
            motivocancelamento_id: item?.reasonForCancellationId,
            ...(configuration?.utiliza_nova_nfse === 1
              ? {
                  perfil_tributario_id:
                    item?.service?.perfil_tributario_id ?? null,
                }
              : {}),
          });
        });

        const upsertContractBody = {
          servico: dataService,
          tipo_servico: modality?.value,
          contrato_id: id,
          usuario_id: queryParams?.usuario_id,
        };

        // Verifico se a agência/tipo de boleto foram alterados
        // independente se é avulso ou recorrente.
        const isBoletoOrTransferency = verifyIsBoletoOrTransferency(
          typePayment?.label
        );

        let editRequestBody = {
          servicos: upsertContractBody,
          formarecebimento: typePayment?.label,
          idtipopagamento: typePayment?.value,
          idformapagamento: formOfPayment?.value || null,
          reajusteperiod: periodicity?.value || null,
          dia_vencimento: modality?.value && dayDueDate ? dayDueDate : null,
          regime_competencia: regimeCompetency?.value,
          idtipocontrato: typeService?.value,
          tipo_aprovacao_id: approvalType?.value,
          origem_lead_id: leadOrigin?.value || null,
          tipo_venda_id: saleType?.value || null,
          cliente_responsavel_financeiro_id: financialResponsibleEnabled
            ? financialResponsibleInfos?.id || null
            : null,
          id_vendedor: salesmanInfos?.id,
          id_parceirocomercial: commercialPartnerInfos?.id || null,
          obs: observation,
          idtiporeajuste: typeReadjustment?.value,
          flag_gerar_boleto: generateBillet ? 1 : 0,
          flag_emitir_nfse: issueNfse ? 1 : 0,
          flag_valor_nota: valueInNote ? 1 : 0,
          padrao_contrato_tipo_emissao_nfse: issueNfse && !issueType ? 1 : 0,
          flag_gerar_demonstrativo_financeiro: generateFinancialStatement
            ? 1
            : 0,
          flag_enviar_email: sendByEmail ? 1 : 0,
          flag_email_nfse: attachNfse ? 1 : 0,
          flag_email_boleto: attachBillet ? 1 : 0,
          flag_email_demonstrativo_financeiro: attachFinancialStatement ? 1 : 0,
          flag_email_comp_desp: arrachExpense ? 1 : 0,
          applyBillingRule: applyBillingRule,
          idusuario: queryParams?.usuario_id,
          empresa_cnpj: queryParams?.empresa_cnpj,
          total: MaskService.removeMaskDecimal(
            totalService,
            configuration?.contract_decimal_size || 2
          ),
          id_modelo_contrato: modelContract?.value,
          tipoboleto:
            isBoletoOrTransferency && bank?.codBank === "000"
              ? typeBillet.value
              : null,
          idagencia: isBoletoOrTransferency ? bank?.value : null,
          proposta: proposedNumber?.substring(0, 20) || "",
          dataemissao: dateEmission,
          regua_cobranca_id: billingRule?.value || null,
        };

        if (
          !disabledPaymentOptions &&
          modality?.value === GlobalVariables.contract.modality.separate &&
          (editRequestBody.idtipopagamento || editRequestBody.idformapagamento)
        )
          editRequestBody["parcelas"] = itensInstallments.map((attach) => ({
            idcr: attach?.keyService,
            valor: attach?.value,
            vencimento: moment(attach?.dueDate).format("YYYY-MM-DD"),
          }));

        const callbackEdit = await editContract({
          empresa_cnpj: queryParams.empresa_cnpj,
          idContract: id,
          body: { contrato: editRequestBody },
        });

        if (!callbackEdit?.success)
          return notify(
            `${
              callbackEdit.message ||
              "Ocorreu um erro inesperado ao atualizar o contrato."
            }`
          );

        successMsg = callbackEdit?.message || successMsg;

        if (savedAttachments.length > 0) {
          const dataAttachments = [];
          const diff = savedAttachments.filter(
            (x) => !uploadFilesAttachment.includes(x)
          );

          diff.forEach((attachments) => {
            if (attachments?.s3_key) {
              dataAttachments.push({ s3_key: attachments?.s3_key });
            }
          });

          if (dataAttachments.length > 0) {
            const calbackRemoveAttachments = await removeAttachments({
              empresa_cnpj: queryParams?.empresa_cnpj,
              idContract: id,
              body: {
                contratosanexos_keys: dataAttachments,
              },
            });

            if (!calbackRemoveAttachments?.success) {
              return "Erro ao excluir anexos.";
            }
          }
        }
      }

      const dataFileAttachment = [];
      for (let file of uploadFilesAttachment) {
        if (!file?.s3_key) {
          var fileBase64 = await getBase64(file?.file),
            base64 = fileBase64.split(";base64,");
          if (!base64[1]) return notify("Arquivo Invalido.");
          dataFileAttachment.push({
            base64: fileBase64,
            anexo_nome: file?.name,
          });
        }
      }

      if (dataFileAttachment.length > 0) {
        const callbackAttachment = await includeAttachments({
          empresa_cnpj: queryParams?.empresa_cnpj,
          idContract: id,
          body: {
            contratosanexos: dataFileAttachment,
          },
        });

        if (!callbackAttachment.success)
          return notify("Erro ao salvar anexos.");
      }

      notify(successMsg, true, "success");

      if (newContract) {
        push("cadastro?gfAccessToken=" + queryParams.gfAccessToken);
      } else {
        push("listagem?gfAccessToken=" + queryParams.gfAccessToken);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectService = (
    setModalTypeServiceOpen,
    selectedTypeService
  ) => {
    setPerfilTributarioLinhaModal(null);
    setSelectService(selectedTypeService[0]);
    setValueService(
      MaskService.toMask(
        "decimal",
        parseFloat(selectedTypeService[0]?.valor).toFixed(
          configuration?.contract_decimal_size || 2
        ) || 0.0,
        configuration?.contract_decimal_size || 2
      )
    );
    setModalTypeServiceOpen(false);
  };

  const clearConttextModalTypeService = () => {
    setSelectService(null);
    setValueService(
      `0,${"0".repeat(configuration?.contract_decimal_size || 2)}`
    );
    setAmountService("1");
    setPerfilTributarioLinhaModal(null);
  };

  const selectionService = async (id) => {
    const jsonValidMain = [
      {
        key: "selectService",
        value: selectService,
      },
      {
        key: "amountService",
        value: amountService,
      },
    ];

    const validateSubmit = validNotNull(jsonValidMain);

    setErrorsSubmitTypeService({
      ...validateSubmit?.errorsValidation,
    });

    if (validateSubmit?.error)
      return notify(
        "Verifique se os campos foram preenchidos corretamente.",
        true,
        "warning"
      );

    if (configuration?.utiliza_nova_nfse === 1 && selectService?.id) {
      const novoPerfil = perfilTributarioLinhaModal?.id ?? null;
      const perfilAnterior = selectService?.perfil_tributario_id ?? null;

      if (novoPerfil !== perfilAnterior) {
        const persist = await updateServicoCadastroPerfilTributario(
          selectService.id,
          novoPerfil
        );
        if (!persist?.success) {
          return { success: false };
        }
      }
    }

    const index = id ?? itemsTable.length;
    const copyList = [...itemsTable];
    const total =
      MaskService.removeMaskDecimal(
        valueService,
        configuration?.contract_decimal_size || 2
      ) * amountService;
    const mergedService =
      configuration?.utiliza_nova_nfse === 1
        ? {
            ...selectService,
            perfil_tributario_id: perfilTributarioLinhaModal?.id ?? null,
            perfil_tributario: perfilTributarioLinhaModal ?? null,
          }
        : selectService;

    copyList[index] = {
      ...copyList[index],
      id: index,
      service: mergedService,
      valueItem: valueService,
      amountItem: amountService,
      valueTotal: MaskService.toMask(
        "decimal",
        total.toFixed(configuration?.contract_decimal_size || 2),
        configuration?.contract_decimal_size || 2
      ),
      cancelDate: null,
    };

    setItemsTable(copyList);
    return { success: true };
  };

  const tofillInInputService = useCallback(
    (index) => {
      const data = itemsTable[index];
      setSelectService(data?.service);
      setValueService(data?.valueItem);
      setAmountService(data?.amountItem);
    },
    [itemsTable, setSelectService, setValueService, setAmountService]
  );

  const handleTotalService = useCallback(() => {
    var total = 0;

    itemsTable.forEach((service) => {
      if (!service.rowError) {
        total += MaskService.removeMaskDecimal(
          service?.valueTotal,
          configuration?.contract_decimal_size || 2
        );
      }
    });

    setTotalService(
      MaskService.toMask(
        "decimal",
        parseFloat(total).toFixed(configuration?.contract_decimal_size || 2),
        configuration?.contract_decimal_size || 2
      )
    );
  }, [itemsTable, setTotalService, configuration]);

  const handleSelectReasonForCancellatio = (
    setModalReasonForCancellatioOpen,
    selectedTypeService
  ) => {
    setReasonForCancellation(selectedTypeService[0]);
    setModalReasonForCancellatioOpen(false);
  };

  const handleCancelServiceMain = (index, stateId) => {
    const copyItens = [...itemsTable];
    stateId && copyItens[index]?.keyService
      ? (copyItens[index] = {
          ...copyItens[index],
          rowError: true,
          reasonForCancellationId: reasonForCancellation?.id,
        })
      : copyItens.splice(index, 1);
    setItemsTable(copyItens);
  };

  const cancelContract = async (id) => {
    try {
      setMainLoading(true);

      const body = {
        contrato_id: id,
        motivocancelamento_id: reasonForCancellation?.id,
        datavencto_cr: cancelFrom?.datavencto,
        usuario_id: queryParams?.usuario_id,
      };

      const callback = await sendCancelContract({
        empresa_cnpj: queryParams?.empresa_cnpj,
        body: body,
      });

      if (!callback?.success) return { success: false };

      return { success: true };
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleReactivateContract = async (
    id,
    reactivateInstallmentsFrom,
    reason
  ) => {
    try {
      setMainLoading(true);

      const body = {
        reactivateInstallmentsDate: reactivateInstallmentsFrom,
        reason,
      };

      const callback = await reactivateContract(id, body);

      if (!callback?.success) return { success: false };

      return { success: true };
    } catch (error) {
      notify(
        "Ocorreu um erro ao tentar reativar o contrato. Tente novamente mais tarde.",
        true,
        "error"
      );
      console.error(error);
      return { success: false };
    } finally {
      setMainLoading(false);
    }
  };

  const handleSuspensionContract = async (
    id,
    statusContract = GlobalVariables.clientContract.active,
    datavencto_cr = ""
  ) => {
    const isSuspension =
      statusContract === GlobalVariables.clientContract.active;
    Swal.fire({
      icon: "question",
      text: `Tem certeza que deseja ${
        isSuspension ? "suspender" : "reativar"
      } o contrato?`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      try {
        if (result.isConfirmed) {
          setMainLoading(true);
          setLoading(true);

          const body = {
            contrato_id: id,
            usuario_id: queryParams?.usuario_id,
            datavencto_cr,
          };

          const callback = isSuspension
            ? await suspensionContract({
                empresa_cnpj: queryParams?.empresa_cnpj,
                body: body,
              })
            : await activeContract({
                empresa_cnpj: queryParams?.empresa_cnpj,
                body: body,
              });

          if (!callback.success) {
            return notify(
              `Ocorreu um erro ao realizar a ${
                isSuspension ? "suspensão" : "reativar"
              } do contrato. Certifique-se de que se trata de um contrato ativo.`
            );
          }
          setItensTable((current) =>
            current.map((el) => {
              if (el.id === id) {
                return {
                  ...el,
                  status: isSuspension
                    ? GlobalVariables.clientContract.suspended
                    : GlobalVariables.clientContract.active,
                  backgroundColor: isSuspension ? "#e8e1ff" : "white",
                };
              } else return { ...el };
            })
          );

          push("listagem?gfAccessToken=" + queryParams.gfAccessToken);
          return notify(callback.message, true, "success");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
        setLoading(false);
      }
    });
  };

  const handleFormOfPayment = useCallback(async () => {
    if (!typePayment) {
      setListFormOfPayment([]);
      return;
    }

    setFormOfPayment(null);
    setListFormOfPayment(typePayment.formaspgto);
  }, [typePayment, setListFormOfPayment, setFormOfPayment]);

  const apportionment = useCallback(
    (
      value,
      divider,
      decimalSize = configuration?.contract_decimal_size || 2
    ) => {
      const factor = 10 ** decimalSize;
      const aux = Math.floor((value / divider) * factor);
      const chargeFinalValue = aux / factor;
      const rest = value - chargeFinalValue * divider;

      return {
        parcel: chargeFinalValue,
        rest: rest,
      };
    },
    [configuration?.contract_decimal_size]
  );

  const handleInstallmentsTable = useCallback(
    (newFormOfPayment) => {
      setFormOfPayment(newFormOfPayment);

      const isSeparateContract =
        modality?.value === GlobalVariables.contract.modality.separate;
      const paymentConditions = newFormOfPayment?.parcelas_condicao_pgto || [];

      const valueInstallments = apportionment(
        MaskService.removeMaskDecimal(
          totalService,
          configuration?.contract_decimal_size || 2
        ),
        newFormOfPayment?.amount,
        configuration?.contract_decimal_size || 2
      );

      let installments = [];
      if (
        initialBillingInformation &&
        initialBillingInformation.typePayment === typePayment &&
        initialBillingInformation.formOfPayment === newFormOfPayment
      ) {
        installments = initialBillingInformation.itensInstallments.map(
          (item) => ({
            ...item,
            value: valueInstallments.parcel,
          })
        );
      } else {
        for (let i = 1; i <= newFormOfPayment?.amount; i++) {
          const installmentPaymentCondition = paymentConditions.find(
            (condition) => condition?.ni_numero_parcela === i
          );
          const dueDateByCondition = isSeparateContract
            ? moment().add(
                installmentPaymentCondition?.ni_parcelas ?? 0,
                "days"
              )
            : moment().add(i, "month");

          installments.push({
            documentNumber: `${i}/${newFormOfPayment.amount}`,
            dueDate: dueDateByCondition,
            value: valueInstallments.parcel,
          });
        }
      }

      // adiciona valor do resto na última parcela gerada.
      if (valueInstallments.rest) {
        const { parcel, rest } = valueInstallments;

        installments[installments.length - 1] = {
          ...installments[installments.length - 1],
          value: parcel + rest,
        };
      }

      setItensInstallments(installments);
    },
    [
      apportionment,
      configuration?.contract_decimal_size,
      initialBillingInformation,
      modality,
      totalService,
      typePayment,
      setFormOfPayment,
      setItensInstallments,
    ]
  );

  const removeInstallments = () => {
    setFormOfPayment(null);
    setItensInstallments([]);
  };

  const getCancelledInstallments = async (id, setLoadingList, setList) => {
    try {
      setLoadingList(true);
      const listsCallback = await getContractCancelledInstallments(id);

      if (!listsCallback?.success)
        return notify(
          "Ocorreu um erro ao buscar as parcelas, tente novamente."
        );
      setList(
        listsCallback.data.map((cr) => ({
          ...cr,
          value: moment(cr.dueDate).format("DD/MM/YYYY"),
        }))
      );
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingList(false);
    }
  };

  const updateServicoCadastroPerfilTributario = useCallback(
    async (servicoId, perfilTributarioId) => {
      if (!servicoId) {
        return { success: false };
      }
      try {
        const callback = await updateContratoServico({
          id: servicoId,
          empresa_cnpj: queryParams.empresa_cnpj,
          body: {
            contratoservicos: {
              perfil_tributario_id: perfilTributarioId ?? null,
            },
          },
        });
        if (!callback?.success) {
          notify(
            callback?.message ||
              "Não foi possível gravar o perfil tributário no cadastro do serviço.",
            true,
            "error"
          );
          return { success: false };
        }
        return { success: true };
      } catch (e) {
        console.error(e);
        notify(
          "Erro ao gravar o perfil tributário no cadastro do serviço.",
          true,
          "error"
        );
        return { success: false };
      }
    },
    [queryParams.empresa_cnpj]
  );

  const getContasReceber = useCallback(
    async (id, setLoadingList, setList) => {
      try {
        setLoadingList(true);

        const listsCallback = await getCancelLists({
          contractId: id,
          empresa_cnpj: queryParams.empresa_cnpj,
        });

        if (!listsCallback?.success || !listsCallback?.data?.datavencto_cr)
          return notify(
            "Ocorreu um erro ao buscar a lista de vencimentos, tente novamente."
          );

        setList(
          listsCallback.data.datavencto_cr.map((cr) => ({
            ...cr,
            value: moment(cr.datavencto).format("DD/MM/YYYY"),
          })) || []
        );
      } catch (e) {
      } finally {
        setLoadingList(false);
      }
    },
    [queryParams.empresa_cnpj]
  );

  const verifyIsBoletoOrTransferency = useCallback(
    (label = "", conditions = ["boleto", "transferência", "transferencia"]) => {
      let splittedLabel = label.split(" "),
        isBoletoOrTransferency = false;

      splittedLabel.forEach((word) => {
        if (conditions.includes(word.trim().toLowerCase()))
          isBoletoOrTransferency = true;
      });

      return isBoletoOrTransferency;
    },
    []
  );

  const createPdf = async (contratoId) => {
    var values = [];
    var contractCallback = await customShowContract({
      empresa_cnpj: queryParams.empresa_cnpj,
      idContract: contratoId,
      gfToken: queryParams.gfAccessToken,
    });
    var tagCallback = await findTag({
      empresa_cnpj: queryParams.empresa_cnpj,
      orderByColumn: "id",
    });

    if (!contractCallback.success)
      return notify("Erro Ao Fazer Download Do Contrato!");

    var htmlBody = contractCallback?.data?.contratomodelo?.main_body ?? "";

    var telefoneCliente = "";
    if (contractCallback?.data?.cliente?.telefone1) {
      telefoneCliente = `(${contractCallback?.data?.cliente?.ddd1 ?? ""})`;
      if (contractCallback?.data?.cliente?.telefone1.length > 8) {
        telefoneCliente += `${contractCallback?.data?.cliente?.telefone1.substring(
          0,
          5
        )}-${contractCallback?.data?.cliente?.telefone1.substring(5)}`;
      } else {
        telefoneCliente += `${contractCallback?.data?.cliente?.telefone1.substring(
          0,
          4
        )}-${contractCallback?.data?.cliente?.telefone1.substring(4)}`;
      }
    }

    var telefoneEmpresa = "";
    if (contractCallback?.data?.empresa?.telefone1) {
      if (contractCallback?.data?.empresa?.telefone1.length > 10) {
        telefoneEmpresa += `(${contractCallback?.data?.empresa?.telefone1.substring(
          0,
          2
        )}) ${contractCallback?.data?.empresa?.telefone1.substring(
          2,
          7
        )}-${contractCallback?.data?.empresa?.telefone1.substring(7)}`;
      } else {
        telefoneEmpresa += `(${contractCallback?.data?.empresa?.telefone1.substring(
          0,
          2
        )}) ${contractCallback?.data?.empresa?.telefone1.substring(
          2,
          6
        )}-${contractCallback?.data?.empresa?.telefone1.substring(6)}`;
      }
    }

    var periodicidade = "";
    if (contractCallback?.data?.reajusteperiod) {
      switch (contractCallback?.data?.reajusteperiod) {
        case 1:
          periodicidade = "Mensal";
          break;
        case 2:
          periodicidade = "Bimestral";
          break;
        case 3:
          periodicidade = "Trimestral";
          break;
        case 6:
          periodicidade = "Semestral";
          break;
        case 12:
          periodicidade = "Anual";
          break;
        default:
          periodicidade = "";
      }
    }

    var tipoReajuste = "";
    if (contractCallback?.data?.idtiporeajuste) {
      switch (contractCallback?.data?.idtiporeajuste) {
        case 1:
          tipoReajuste = "IGPM AC 12";
          break;
        case 2:
          tipoReajuste = "IPCA";
          break;
        case 3:
          tipoReajuste = "Salário Mínimo";
          break;
        default:
          tipoReajuste = "";
      }
    }

    var itensBody = "";
    if (contractCallback?.data?.contratoitens) {
      itensBody = `<div class="u-row-container" style="padding: 0px;background-color: transparent">
      <div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 695px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;">
        <div style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;">
          <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:695px;"><tr style="background-color: transparent;"><![endif]-->
          
    <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
    <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
      <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
      <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
      
    <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
      <tbody>
        <tr>
          <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
            
      <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
        <p style="line-height: 140%;"><strong>Código</strong></p>
      </div>
    
          </td>
        </tr>
      </tbody>
    </table>
    
      <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
      </div>
    </div>
    <!--[if (mso)|(IE)]></td><![endif]-->
    <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
    <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
      <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
      <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
      
    <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
      <tbody>
        <tr>
          <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
            
      <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
        <p style="line-height: 140%;"><strong>Descrição</strong></p>
      </div>
    
          </td>
        </tr>
      </tbody>
    </table>
    
      <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
      </div>
    </div>
    <!--[if (mso)|(IE)]></td><![endif]-->
    <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
    <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
      <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
      <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
      
    <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
      <tbody>
        <tr>
          <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
            
      <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
        <p style="line-height: 140%;"><strong>Qtde</strong></p>
      </div>
    
          </td>
        </tr>
      </tbody>
    </table>
    
      <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
      </div>
    </div>
    <!--[if (mso)|(IE)]></td><![endif]-->
    <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
    <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
      <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
      <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
      
    <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
      <tbody>
        <tr>
          <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
            
      <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
        <p style="line-height: 140%;"><strong>Vlr Unit.</strong></p>
      </div>
    
          </td>
        </tr>
      </tbody>
    </table>
    
      <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
      </div>
    </div>
    <!--[if (mso)|(IE)]></td><![endif]-->
    <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
    <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
      <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
      <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
      
    <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
      <tbody>
        <tr>
          <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
            
      <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
        <p style="line-height: 140%;"><strong>Vlr Total</strong></p>
      </div>
    
          </td>
        </tr>
      </tbody>
    </table>
    
      <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
      </div>
    </div>
    <!--[if (mso)|(IE)]></td><![endif]-->
          <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
        </div>
      </div>
    </div>`;
      contractCallback?.data?.contratoitens.forEach((iten) => {
        if (iten?.motivocancelamento_id == null) {
          itensBody +=
            `<div class="u-row-container" style="padding: 0px;background-color: transparent">
          <div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 695px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;">
            <div style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;">
              <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:695px;"><tr style="background-color: transparent;"><![endif]-->
              
        <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
        <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
          <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
          <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
          
        <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
          <tbody>
            <tr>
              <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
                
          <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
            <p style="line-height: 140%;">` +
            iten?.contratoservicos.id +
            `</p>
          </div>
        
              </td>
            </tr>
          </tbody>
        </table>
        
          <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
          </div>
        </div>
        <!--[if (mso)|(IE)]></td><![endif]-->
        <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
        <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
          <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
          <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
          
        <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
          <tbody>
            <tr>
              <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
                
          <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
            <p style="line-height: 140%;">` +
            iten.contratoservicos.descricao +
            `</p>
          </div>
        
              </td>
            </tr>
          </tbody>
        </table>
        
          <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
          </div>
        </div>
        <!--[if (mso)|(IE)]></td><![endif]-->
        <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
        <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
          <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
          <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
          
        <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
          <tbody>
            <tr>
              <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
                
          <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
            <p style="line-height: 140%;">` +
            iten.quantidade +
            `</p>
          </div>
        
              </td>
            </tr>
          </tbody>
        </table>
        
          <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
          </div>
        </div>
        <!--[if (mso)|(IE)]></td><![endif]-->
        <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
        <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
          <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
          <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
          
        <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
          <tbody>
            <tr>
              <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
                
          <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
            <p style="line-height: 140%;">R$ ` +
            MaskService.toMask(
              "decimal",
              parseFloat(iten.valorunitario || 0).toFixed(
                configuration?.contract_decimal_size || 2
              ),
              configuration?.contract_decimal_size || 2
            ) +
            `</p>
          </div>
        
              </td>
            </tr>
          </tbody>
        </table>
        
          <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
          </div>
        </div>
        <!--[if (mso)|(IE)]></td><![endif]-->
        <!--[if (mso)|(IE)]><td align="center" width="139" style="width: 139px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]-->
        <div class="u-col u-col-20" style="max-width: 320px;min-width: 139px;display: table-cell;vertical-align: top;">
          <div style="height: 100%;width: 100% !important;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;">
          <!--[if (!mso)&(!IE)]><!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;"><!--<![endif]-->
          
        <table style="font-family:arial,helvetica,sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">
          <tbody>
            <tr>
              <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif;" align="left">
                
          <div style="font-size: 14px; line-height: 140%; text-align: left; word-wrap: break-word;">
            <p style="line-height: 140%;">R$ ` +
            MaskService.toMask(
              "decimal",
              parseFloat(iten.valortotal || 0).toFixed(
                configuration?.contract_decimal_size || 2
              ),
              configuration?.contract_decimal_size || 2
            ) +
            `</p>
          </div>
        
              </td>
            </tr>
          </tbody>
        </table>
        
          <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
          </div>
        </div>
        <!--[if (mso)|(IE)]></td><![endif]-->
              <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
            </div>
          </div>
        </div>`;
        }
      });
    }
    values.push(
      MaskService.toMask(
        contractCallback?.data?.cliente?.cpfcnpj.length < 12 ? "cpf" : "cnpj",
        contractCallback?.data?.cliente?.cpfcnpj
      ),
      contractCallback?.data?.cliente?.razao,
      contractCallback?.data?.cliente?.endereco,
      contractCallback?.data?.cliente?.complemento,
      contractCallback?.data?.cliente?.bairro,
      contractCallback?.data?.cliente?.cidade,
      contractCallback?.data?.cliente?.estado?.estado,
      contractCallback?.data?.cliente?.ie,
      telefoneCliente,
      contractCallback?.data?.cliente?.email,
      contractCallback?.data?.cliente?.id,
      MaskService.toMask(
        contractCallback?.data?.empresa?.cnpj_cpf.length < 12 ? "cpf" : "cnpj",
        contractCallback?.data?.empresa?.cnpj_cpf
      ),
      contractCallback?.data?.empresa?.nomeempresa,
      contractCallback?.data?.empresa?.endereco,
      contractCallback?.data?.empresa?.complemento,
      contractCallback?.data?.empresa?.bairro,
      contractCallback?.data?.empresa?.cidade,
      contractCallback?.data?.empresa?.estado?.estado,
      contractCallback?.data?.empresa?.inscricao_estadual,
      telefoneEmpresa,
      contractCallback?.data?.empresa?.emailfinanceiro,
      contractCallback?.data?.numero,
      contractCallback?.data?.dataemissao
        ? MaskService.dateYmdToDmy(contractCallback?.data?.dataemissao)
        : "",
      contractCallback?.data?.modalidade ===
        GlobalVariables.contract.modality.recurring
        ? "Recorrente"
        : "Avulso",
      tipoReajuste,
      periodicidade,
      contractCallback?.data?.contratoitens?.contratoservicos?.id,
      contractCallback?.data?.contratoitens?.contratoservicos?.descricao,
      contractCallback?.data?.contratoitens?.quantidade,
      contractCallback?.data?.contratoitens?.valorunitario,
      contractCallback?.data?.contratoitens?.valortotal,
      "R$ " +
        MaskService.toMask(
          "decimal",
          parseFloat(contractCallback?.data?.total || 0).toFixed(
            configuration?.contract_decimal_size || 2
          ),
          configuration?.contract_decimal_size || 2
        ),
      contractCallback?.data?.tipopagamento?.descricao,
      contractCallback?.data?.formapagamento?.descricao,
      contractCallback?.data?.dia_vencimento,
      contractCallback?.data?.datavencimento1
        ? MaskService.dateYmdToDmy(contractCallback?.data?.datavencimento1)
        : "",
      contractCallback?.data?.id,
      contractCallback?.data?.proposta,
      contractCallback?.data?.obs,
      contractCallback?.data?.cliente?.rg,
      contractCallback?.data?.cliente?.cep,
      contractCallback?.data?.empresa?.cep,
      contractCallback?.data?.vigencia_renovacao,
      contractCallback?.data?.empresa?.apelido,
      contractCallback?.data?.cliente?.apelido,
      contractCallback?.data?.empresa?.numero,
      itensBody
    );

    tagCallback?.data.forEach((tag, index) => {
      htmlBody = htmlBody.replaceAll(tag.valor, values[index] || "");
    });

    const regex = ";width: 100%;max-width:";
    const maxWidthRegex = /%;max-width:\s*(\d+(\.\d+)?)px;"/g;
    const listMaxWidth = [];
    var loopstop = false;
    do {
      const maxWidthMatch = maxWidthRegex.exec(htmlBody);
      if (maxWidthMatch) {
        listMaxWidth.push(maxWidthMatch[1]);
      } else {
        loopstop = true;
      }
    } while (!loopstop);

    // eslint-disable-next-line array-callback-return
    listMaxWidth.map((maxwidth) => {
      htmlBody = htmlBody.replace(regex, `;width: ${maxwidth}px;max-width:`);
    });

    const callbackPdf = await downloadPdf({
      title: "Modelo Contrato",
      login: "string usuario logado",
      html: btoa(unescape(encodeURIComponent(htmlBody))),
      showThisPage: contractCallback?.data?.contratomodelo?.pages_number,
      showThisTotalPages: contractCallback?.data?.contratomodelo?.pages_total,
    });

    if (callbackPdf.status !== 200)
      return notify("Erro Ao Fazer Download Do Contrato!");

    return {
      pdf: callbackPdf?.data?.fileBase64,
    };
  };

  const handleDownloadPdf = async (contratoId, download = false) => {
    try {
      setMainLoading(true);

      var callbackPdf = await createPdf(contratoId);
      if (download) {
        const file = atob(callbackPdf?.pdf);

        if (!file) return notify("Ocorreu um erro ao tentar gerar o PDF");

        var element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:application/octet-stream;base64," +
            encodeURIComponent(
              file.substring(file.split("").findIndex((e) => e === ",") + 1)
            )
        );
        element.setAttribute("download", `Contrato-${contratoId}.pdf`);
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        return true;
      } else {
        const blob = b64toBlob(callbackPdf?.pdf, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const sendEmailPdf = async (contratoId, mails, setModal) => {
    if (!mails.length) {
      return notify("Nenhum Email Informado.");
    }

    try {
      setMainLoading(true);

      var callbackPdf = await createPdf(contratoId);

      const body = {
        id: contratoId,
        emails: mails,
        pdf: callbackPdf?.pdf,
      };

      const callbackSendEmail = await sendEmail({
        empresa_cnpj: queryParams?.empresa_cnpj,
        body,
      });
      setModal(false);
      return notify(
        callbackSendEmail.message,
        true,
        callbackSendEmail.success ? "success" : "error"
      );
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleFirstDueDate = useCallback(
    (prop) => {
      setFirstDueDate(prop.target.value);

      const tempFirstDueDate = moment(prop.target.value);
      if (!tempFirstDueDate.isValid()) {
        return notify("Data do 1º vencimento é inválida.", true, "warning");
      }

      setDayDueDate(tempFirstDueDate.format("D"));
    },
    [setFirstDueDate, setDayDueDate]
  );

  const handleDayDueDate = useCallback(
    (prop) => {
      const tempDayDueDate = prop.target.value;

      if (
        tempDayDueDate &&
        !isNaN(tempDayDueDate) &&
        tempDayDueDate >= 1 &&
        tempDayDueDate <= 31
      ) {
        setDayDueDate(tempDayDueDate);
      }
    },
    [setDayDueDate]
  );

  const refreshLeadOriginList = useCallback(async () => {
    const options = await fetchLeadOriginOptions();
    setListLeadOrigin(options || []);
    return options || [];
  }, [setListLeadOrigin]);

  const refreshSaleTypeList = useCallback(async () => {
    const options = await fetchSaleTypeOptions();
    setListSaleType(options || []);
    return options || [];
  }, [setListSaleType]);

  const handleLeadOriginSaved = useCallback(
    async (savedItem) => {
      const options = await refreshLeadOriginList();
      const selected =
        options.find((item) => item.value === savedItem.value) || savedItem;
      setLeadOrigin(selected);
    },
    [refreshLeadOriginList, setLeadOrigin]
  );

  const handleSaleTypeSaved = useCallback(
    async (savedItem) => {
      const options = await refreshSaleTypeList();
      const selected =
        options.find((item) => item.value === savedItem.value) || savedItem;
      setSaleType(selected);
    },
    [refreshSaleTypeList, setSaleType]
  );

  return {
    handleSelectClient,
    handleSelectFinancialResponsible,
    handleSelectSalesman,
    handleData,
    confirmEditContract,
    handleSelectService,
    clearConttextModalTypeService,
    selectionService,
    tofillInInputService,
    handleTotalService,
    handleSelectReasonForCancellatio,
    handleCancelServiceMain,
    cancelContract,
    handleFormOfPayment,
    handleInstallmentsTable,
    removeInstallments,
    getContasReceber,
    getCancelledInstallments,
    handleReactivateContract,
    handleSelectCommercialPartner,
    verifyIsBoletoOrTransferency,
    handleSuspensionContract,
    handleDownloadPdf,
    sendEmailPdf,
    handleFirstDueDate,
    handleDayDueDate,
    updateServicoCadastroPerfilTributario,
    refreshLeadOriginList,
    refreshSaleTypeList,
    handleLeadOriginSaved,
    handleSaleTypeSaved,
    storeLeadOrigin,
    updateLeadOrigin,
    storeSaleType,
    updateSaleType,
  };
}
